var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-cell-copitext-col"},[_c('span',[_vm._v(" "+_vm._s(_vm.value)+" ")]),(_vm.value)?_c('div',{staticClass:"copy-box",on:{"click":_vm.handlerClick}},[_c('i',{staticClass:"el-icon-search"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }